import { render, staticRenderFns } from "./App_mock.vue?vue&type=template&id=669fdcc5&scoped=true"
import script from "./App_mock.vue?vue&type=script&lang=js"
export * from "./App_mock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669fdcc5",
  null
  
)

export default component.exports